<template>
  <header v-if="compact" class="legacy-mobile-identity">
    <div><strong>{{ _g_SelectedTicker.ticker || 'Selecciona un valor' }}</strong><span>{{ _g_SelectedTicker.entry_type_name }}</span></div>
    <p>{{ _g_SelectedTicker.nom }}</p>
    <small>{{ [_g_SelectedTicker.index_valor, _g_SelectedTicker.country, _g_SelectedTicker.divisa].filter(Boolean).join(' · ') }}</small>
  </header>
  <nav v-else-if="_g_IsUserLogged" class="legacy-mobile-tickers" aria-label="Valores encontrados">
    <span class="legacy-mobile-tickers__count">{{ _g_Stocks.length }}<small>valores</small></span>
    <div ref="strip" class="legacy-mobile-tickers__strip">
      <button v-for="ticker in _g_Stocks" :key="ticker.ticker" type="button"
        :aria-pressed="String(ticker.ticker === (_g_SelectedTicker || {}).ticker)"
        @click="selectTicker(ticker)">
        <span v-if="_g_User.is_pre_eureker_user && ticker.nom === '---'" class="material-icons-outlined" aria-label="Desbloquear valor">visibility</span>
        <template v-else>{{ ticker.ticker }}</template>
      </button>
    </div>
  </nav>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex';
import APICaller from '@/shared/mixins/APICaller';
import GetStocks from '@/shared/mixins/GetStocks';
export default {
  props: { compact: Boolean },
  mixins: [APICaller, GetStocks],
  computed: { ...mapGetters(['_g_Stocks', '_g_SelectedTicker', '_g_IsUserLogged', '_g_User']) },
  watch: { _g_SelectedTicker() { this.$nextTick(this.revealSelected); } },
  mounted() { this.revealSelected(); },
  methods: {
    askPreEurekersTickerInfo(id) {
      let params = new URLSearchParams();
      params.append('ticker_id', id);
      params.append('uid', this._g_User.uid);

      let success= response => {
        this.getStocks();
        this.getPreEurekersRemainingTickers();
      };

      let url = '/usuarios/add-requested-ticker';

      const successHandler = new APICaller.SuccessHandler(success);
      const failureHandler = new APICaller.FailureHandler('252', 'Error agregando valor.');

      this._postAPICall(url, params, successHandler, failureHandler);
    },

    getPreEurekersRemainingTickers() {
      let success = response => {
        this.$vueOnToast.pop('success', 'Te quedan ' + response.data + ' visualizaciones disponibles');
        //TODO actualizar el objeto _g_User pedir info del back
      };
      
      let url = '/usuarios/get-remaining-ticker-requests';
            
      const successHandler = new APICaller.SuccessHandler(success);
      const failureHandler = new APICaller.FailureHandler('056', 'Error procesando la solicitud.');

      this._getAPICall(url, successHandler, failureHandler);
    },


    ...mapMutations(['setSelectedTicker']),
    selectTicker(ticker) {
      if (this._g_User.is_pre_eureker_user && ticker.nom === '---') return this.askPreEurekersTickerInfo(ticker.ticker);
      this.setSelectedTicker(ticker);
    },
    revealSelected() {
      const strip = this.$refs.strip;
      const button = strip && strip.querySelector('[aria-pressed="true"]');
      if (!button) return;
      if (button.offsetLeft < strip.scrollLeft) strip.scrollLeft = button.offsetLeft;
      else if (button.offsetLeft + button.offsetWidth > strip.scrollLeft + strip.clientWidth) strip.scrollLeft = button.offsetLeft + button.offsetWidth - strip.clientWidth;
    }
  }
};
</script>
<style scoped>
.legacy-mobile-tickers { display: flex; min-width: 0; border-block: 1px solid #8884; }
.legacy-mobile-tickers__count { min-width: 58px; padding: 4px 8px; text-align: center; background: var(--color-primary-primary, #11111e); color: white; font-size: 19px; }
small { display: block; font-size: 11px; }
.legacy-mobile-tickers__strip { display: flex; position: relative; min-width: 0; overflow-x: auto; }
button { flex: 0 0 auto; min-height: 48px; padding: 8px 14px; border: 0; border-right: 1px solid #8884; background: var(--color-surface, white); color: inherit; font: inherit; font-size: 14px; cursor: pointer; }
button[aria-pressed="true"] { color: #007e9e; box-shadow: inset 0 -3px #00add9; font-weight: bold; }
</style>
